import React from "react";
import { useSelector } from "react-redux";
import type { UserState } from "../redux-context/user";
import { Row, Typography } from "antd";
import ErrorBG from "assets/images/error-bg.png";

const getBusinessId = () => {
  return localStorage.getItem("businessId") || null;
};

const BusinessIdGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const user = useSelector((state: UserState) => state.user);
  const businessId = user?.loggedUser?.defaultBusinessId || getBusinessId();

  if (!businessId) {
    return (
      <div style={{ textAlign: "center" }}>
        <Typography.Title level={3} style={{ marginBottom: 40 }}>
          Account Issue
        </Typography.Title>

        <Typography.Text className="text-regular">
          Your account is missing a required business information.
          <br />
          Please contact support at{" "}
          <a href="mailto:cs@mustard.love">cs@mustard.love</a>
        </Typography.Text>

        <Row justify="center">
          <img
            src={ErrorBG}
            alt="Error"
            style={{ maxWidth: "100%", height: "auto", margin: "60px 0" }}
          />
        </Row>
      </div>
    );
  }

  return <>{children}</>;
};

export default BusinessIdGuard;
